import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23800094"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 新增角色 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 编 辑 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 删 除 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 查看用户 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("关闭")

import { ref, Ref, reactive, onBeforeMount } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import AuthorizationTable from "@/components/AuthorizationTable.vue"
import Api from '@/http/modules/index'
interface Power {
  res: string
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let {
  // 角色列表
  'GET/roles': fetchListApi,
  // 资源列表
  'GET/resources': resourcesListsApi,
  // 新增角色
  'POST/roles': addFetchRolesApi,
  // 编辑角色
  'PUT/roles': editRolesApi,
  // 删除角色
  'DELETE/roles/{id}': deleteRoleApi,
  // 获取所有团队
  'GET/organizations': organizationsApi,
  // 获取某个角色，被多少人使用
  'GET/roles/:id/use': roleUserApi,
  // 移除用户对应的角色
  'DELETE/role_user/user': delRoleUserApi,
} = Api

const { 
  MI_height, MI_tableData, fetchData, 
  MI_identify, MI_params, MI_modifyForm 
} = new tbMix(fetchListApi)

// 权限list
let privileges=ref<any>([])
// 团队list
const orgsList=ref([])
// 资源list
const optionsArr=ref<any>([])

// let sourceTb:any=reactive([])
// 新增角色
let addTitle = ref('新增角色')
const addFg = ref<boolean>(false)
const addConfig = ref<FromConfig[]>([
  {
    label: '角色Id',
    value: '',
    upKey: 'id',
    rule: [
      { required: true, message: '请输入角色Id', trigger: 'change' },
      { pattern: /^(?!_)[a-zA-Z_]+$/, message: '请输入英文字母', trigger: 'change' },
    ],
    props: {
      disabled: false
    },
  },
  {
    label: '角色名',
    value: '',
    upKey: 'name',
    rule: [
      { required: true, message: '请输入角色名', trigger: 'change' },
    ]
  },
  {
    label: '描述',
    value: '',
    upKey: 'description',
  },
])

onBeforeMount(()=>{
  fetchData()
  // 获取团队数据
  organizationsApi().then((rep:any)=>{
    orgsList.value = rep
  })
  // 获取资源
  resourcesListsApi().then(rep=>{
    /* optionsArr.value = JSON.parse(JSON.stringify(rep))
    optionsArr.value.forEach((el:any) => {
      el.label = el.name
    }) */
    optionsArr.value = rep.map((resource: any) => {
      resource.label = resource.name
      return resource
    })
  })
})

// 映射可用资源
const dataChange = (arr:any)=>{
  privileges.value=arr
}

// 增加角色
let sourceTbRowData = ref<any>({})
const addRole=async () => {
  addConfig.value[0]['props' as FromConfig['']].disabled = false
  addTitle.value = '新增角色'
  sourceTbRowData.value = {}

  MI_modifyForm({}, addConfig, addFg, async (params: any) => {
    await addFetchRolesApi({...params, privileges:privileges.value})
    ElMessage.success('添加成功')
    addFg.value = false
    fetchData()
  })
}
// 修改角色
const editRowHandle = async (row:any)=>{
  addConfig.value[0]['props' as FromConfig['']].disabled = true
  addTitle.value = '修改角色'
  
  sourceTbRowData.value=row
  privileges.value = row.privileges
  MI_modifyForm(row, addConfig, addFg, async (params: any) => {
    await editRolesApi({...params, privileges:privileges.value})
    ElMessage.success('修改成功')
    addFg.value = false
    fetchData()
  })
}
// 删除角色
const deleteRole = async (row:any)=>{
  await ElMessageBox.confirm(
    '确认删除？' + row.name,
    '警告',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
  await deleteRoleApi({id:row.id})
  ElMessage.success('删除成功')
  fetchData()
}
const userVisiable=ref(false)
const currentRole=ref<any>({})
const roleUserList=ref([])
const roleUserLoading=ref(false)
const checkUserList=(data:any)=>{
  currentRole.value=data
  userVisiable.value=true
  getUserList(data.id)
}
const getUserList=(id:any)=>{
  roleUserLoading.value=true
  roleUserApi({id}).then((res:any)=>{
    roleUserList.value=res
  }).finally(()=>{
    roleUserLoading.value=false
  })
}
const removeRoleUser=(data:any)=>{
  ElMessageBox.confirm('确定将该人员从当前角色中移除？',{confirmButtonText:"确定",cancelButtonText:"取消"}).then(()=>{
    let params={
      user_id:data.userId,
      role_id:currentRole.value.id    
    }
    delRoleUserApi(params).then(()=>{
      ElMessage.success('删除成功')
      getUserList(currentRole.value.id)
    })
  })
 
}

return (_ctx: any,_cache: any) => {
  const _component_QuestionFilled = _resolveComponent("QuestionFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      type: "primary",
      class: "mt-10",
      onClick: addRole
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createVNode(_component_el_tooltip, {
          effect: "dark",
          placement: "bottom",
          content: "角色是资源的合集,给用户分配角色,相当于给用户分配角色对应的资源合集"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_QuestionFilled)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })), [
      [_directive_permission, 'Create']
    ]),
    _createVNode(_component_el_divider),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      border: "",
      data: _unref(MI_tableData),
      "max-height": _unref(MI_height) + 30 + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "角色ID",
          prop: "id"
        }),
        _createVNode(_component_el_table_column, {
          label: "角色名",
          prop: "name"
        }),
        _createVNode(_component_el_table_column, {
          label: "描述",
          prop: "description",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "可用资源",
          prop: "privileges",
          width: "900"
        }, {
          default: _withCtx(({row}) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.privileges, (power) => {
              return (_openBlock(), _createBlock(_component_el_tag, { class: "ml-10 mb-10" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString((power as Power).res), 1)
                ]),
                _: 2
              }, 1024))
            }), 256))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "操作" }, {
          default: _withCtx(({row}) => [
            _withDirectives((_openBlock(), _createBlock(_component_el_link, {
              onClick: ($event: any) => (editRowHandle(row))
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 2
            }, 1032, ["onClick"])), [
              [_directive_permission, 'Write']
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_el_link, {
              type: "danger",
              onClick: ($event: any) => (deleteRole(row))
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 2
            }, 1032, ["onClick"])), [
              [_directive_permission, 'Delete']
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_el_link, {
              onClick: ($event: any) => (checkUserList(row))
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 2
            }, 1032, ["onClick"])), [
              [_directive_permission, 'Delete']
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_dialog, {
      title: _unref(addTitle),
      modelValue: addFg.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((addFg).value = $event)),
      top: "100px",
      "destroy-on-close": "",
      "close-on-click-modal": false,
      width: "1300px"
    }, {
      default: _withCtx(() => [
        (addFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: addConfig.value,
          submitText: '确定',
        })), {
              BefaultBtnGroup: _withCtx(() => [
                _createVNode(_component_el_button, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (addFg.value = false))
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                })
              ]),
              custom: _withCtx(() => [
                _createVNode(_component_el_alert, {
                  title: "角色是资源的合集,给用户分配角色,相当于给用户分配角色对应的资源合集",
                  type: "warning",
                  effect: "dark",
                  closable: false
                }),
                (addFg.value)
                  ? (_openBlock(), _createBlock(AuthorizationTable, {
                      key: 0,
                      orgsList: orgsList.value,
                      onDataChange: dataChange,
                      sourceTbRowData: _unref(sourceTbRowData),
                      optionsArr: optionsArr.value
                    }, null, 8, ["orgsList", "sourceTbRowData", "optionsArr"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "使用人员名单",
      onClose: _cache[3] || (_cache[3] = ($event: any) => (roleUserList.value=[])),
      modelValue: userVisiable.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((userVisiable).value = $event)),
      width: "900"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (userVisiable.value=false))
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: roleUserList.value,
          "max-height": "500",
          border: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "姓名",
              prop: "name",
              formatter: (row)=>`${row.alias} (${row.name})`
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "状态",
              prop: "staffType"
            }),
            _createVNode(_component_el_table_column, { label: "操作" }, {
              default: _withCtx(({row}) => [
                _createVNode(_component_el_link, {
                  type: "danger",
                  onClick: ($event: any) => (removeRoleUser(row)),
                  underline: false
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, roleUserLoading.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})